<template>
  <div class="d-flex flex-column align-items-center justify-content-start border rounded py-3 h-100">
    <p>{{ $t("backend.candidacy.components.jumbotron.orientation") }}</p>
    <div class="btn-group" role="group" aria-label="Layout orientation">
      <input
        type="radio"
        value='ltr'
        :checked='currentValue ==="ltr"'
        :name="scopeToName([...scope, 'direction'])"
        id="jumbotron-layout-ltr"
        class="btn-check"
        autocomplete="off"
        @click="switchOrientation('ltr')"
      />
      <label class="btn btn-outline-primary py-2" for="jumbotron-layout-ltr">
        <span
          class="d-flex align-items-center justify-content-center lh-1 gap-2"
          :aria-label="$t('backend.candidacy.components.jumbotron.ltr')"
        >
          <i class="fa fa-image" />
          <i class="fa fa-arrow-right" />
          <i class="fa fa-align-left" />
        </span>
      </label>
      <input
        type="radio"
        value='rtl'
        :checked='currentValue === "rtl"'
        :name="scopeToName([...scope, 'direction'])"
        id="jumbotron-layout-rtl"
        class="btn-check"
        autocomplete="off"
        @click="switchOrientation('rtl')"
      />
      <label class="btn btn-outline-primary py-2" for="jumbotron-layout-rtl">
        <span
          class="d-flex align-items-center justify-content-center lh-1 gap-2"
          :aria-label="$t('backend.candidacy.components.jumbotron.rtl')"
        >
          <i class="fa fa-align-right" />
          <i class="fa fa-arrow-left" />
          <i class="fa fa-image" />
        </span>
      </label>
    </div>

    <input
      type="hidden"
      v-model="currentValue"
      :id="scopeToId([...scope, 'direction'])"
      :name="scopeToName([...scope, 'direction'])"
    />
  </div>
</template>

<script setup lang="ts">
import { ref, watch } from "vue";
import type { PropType, LayoutOrientation } from "@/types";
import { scopeToName, scopeToId } from "@/lib/candidacy/form_builder/utils";

const emits = defineEmits(["update:direction"]);

const props = defineProps({
  direction: {
    type: String as PropType<LayoutOrientation>,
    required: true,
  },
  scope: {
    type: Array as PropType<string[]>,
    required: true,
  },
});

const currentValue = ref<LayoutOrientation>(props.direction)

const switchOrientation = (newDir: LayoutOrientation) => {
  currentValue.value = newDir;
};

watch(currentValue, () => {
  emits("update:direction", currentValue.value);
});
</script>
